<script>
import { patientsPortalStore } from './patientsPortalStore';
import EnumService from '@/services/enum.service';
import Utils from '@/common/utils';
import DBFunctions from '@/common/DBFunctions.js';
import PatientPortalsService from '@/services/patientportals.service';

export default {
    name: 'PatientsPortalBase',
    mixins: [DBFunctions],
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                btnvisible: false,
                ItemsList: [],
                favButtonAtion: false
            },
            RightMenuList: JSON.parse(JSON.stringify(EnumService.PatientsPortalDashboardItems)),
            selectedItems: [],
            //selectedPatientCodeList: [],
            PatientTitle: {
                programName: '',
                fullName: '',
                admitDate: '',
                dischargeDate: '',
                dob: ''
            },
            textEditorVisible: false,
            textEditorValue: '',
            changePasswordVisible: false,
            createLoginVisible: false,
            changeUserNameVisible: false
        };
    },
    computed: {
        patientsPortalStore() {
            return patientsPortalStore;
        },
        /*selectedPatientCode() {
            if (this.selectedPatientCodeList.length === 1) {
                return this.selectedPatientCodeList[0];
            }

            return null;
        },*/
        selectedUserName() {
            if (this.selectedItems.length === 1) {
                return this.selectedItems[0].userName || '';
            }

            return '';
        },
        selectedEmail() {
            if (this.selectedItems.length === 1) {
                return this.selectedItems[0].email || '';
            }

            return '';
        },
        selectedFullName() {
            if (this.selectedItems.length === 1) {
                return this.selectedItems[0].lastName + ', ' + this.selectedItems[0].firstName;
            }

            return '';
        },
        patientCodeFirstOrDefault() {
            if (this.selectedItems.length === 1) {
                return this.selectedItems[0].patientCode;
            }

            return '';
        }
    },
    watch: {
        'patientsPortalStore.updatedAt'() {
            if (!patientsPortalStore.executeAction) {
                return;
            }

            this.handlerClick(patientsPortalStore.executeAction);
        }
    },
    methods: {
        closeTextEditorHandler() {
            this.textEditorVisible = false;
        },

        handlerClick(action) {
            switch (action) {
                case 'CreateCredentials':
                    this.createCredentials();
                    break;
                case 'CreateAuthLogins':
                    this.createAuthLogins();
                    break;
                case 'ChangeUsername':
                    this.changeUserName();
                    break;
                case 'CreateLogin':
                    this.createLogin();
                    break;
                case 'ChangePassword':
                    this.changePassword();
                    break;
                case 'PatientContacts':
                    this.executeView('patients-portal-contacts', false, {
                        id: this.patientCodeFirstOrDefault
                    });
                    break;
                case 'PatientClaims':
                    this.executeView('patients-portal-claims');
                    break;
                case 'ChangePatInfo':
                    this.executeView('patients-portal-change-info', true,
                        this.patientCodeFirstOrDefault ? { id: this.patientCodeFirstOrDefault } : {}
                    );
                    break;
                case 'Messages':
                    this.executeView('patients-portal-message', true);
                    break;
                case 'PatientForms':
                    this.executeView('patients-portal-form');
                    break;
                case 'PatientList':
                    this.executeView('patients-portal', true);
                    break;
                case 'Summary':
                    if (this.selectedItems.length === 1) {
                        patientsPortalStore.selectedItem = this.selectedItems[0];
                    }
                    this.$router.push({
                        name: 'patients-portal-summary',
                        params: { id: this.patientCodeFirstOrDefault || this.$route.params.id }
                    }).catch(() => {});
                    break;
                case 'PatientInfo':
                    if (this.selectedItems.length === 1) {
                        patientsPortalStore.selectedItem = this.selectedItems[0];
                    }
                    this.executeView('patients-portal-info', false, {
                        id: this.patientCodeFirstOrDefault
                    });
                    break;
                default:
                    break;
            }
        },

        executeView(routeName, forceRoute = false, parameters = {}) {
            let patientCodeList = this.selectedItems.map(x => x.patientCode);

            if (patientCodeList.length > 0 || forceRoute) {
                /*sessionStorage.setItem(
                    'PatientPortalPatientCodeList',
                    JSON.stringify({
                        patientCodeList: patientCodeList,
                        selectedItems: this.selectedItems
                    })
                );*/
                this.$router.push({ name: routeName, params: parameters });
            }
        },

        changeUserName() {
            this.changeUserNameVisible = true;
        },

        createLogin() {
            let patientCodeList = this.selectedItems.map(x => x.patientCode);
            PatientPortalsService.verifyLogin({
                patientCode: patientCodeList.length !== 0 ? patientCodeList[0] : '',
                email: this.selectedEmail
            })
                .then(response => {
                    if (response.status == '200') {
                        if (response.data) {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.VerifyLoginMessage', {
                                    email: this.selectedEmail
                                }),
                                'success'
                            );

                            this.$nextTick(() => this.createLoginHandler(response.data));
                        } else {
                            this.createLoginVisible = true;
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        createAuthLogins() {
            PatientPortalsService.createAuthLogins({
                patientCodeList: this.selectedItems.map(x => x.patientCode)
            })
                .then(response => {
                    if (response.status == '200' && response.data) {
                        if (response.data === this.selectedItems.length) {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.AllEntrySuccessfully'),
                                'success'
                            );
                        } else {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.CreatedMessage', {
                                    created: response.data,
                                    total: this.selectedItems.length
                                }),
                                'success'
                            );
                        }

                        this.searchPatient();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        changePassword() {
            this.changePasswordVisible = true;
        },

        afterCreateCredentials() {},

        createCredentials() {
            PatientPortalsService.createCredentials({
                patientCodeList: this.selectedItems.map(x => x.patientCode)
            })
                .then(response => {
                    if (response.status == '200' && response.data) {
                        const data = response.data;

                        if (data.errorsLog && data.errorsLog.length !== 0 && data.recordCount > 0) {
                            this.showErrorsLog(data.errorsLog);
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.SomeEntryCreated'),
                                'warning'
                            );
                        } else if (data.errorsLog && data.errorsLog.length !== 0) {
                            this.showErrorsLog(data.errorsLog);
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.IssuesCreating'),
                                'warning'
                            );
                        } else {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.AllEntrySuccessfully'),
                                'success'
                            );
                        }
                        this.afterCreateCredentials();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        showErrorsLog(errors) {
            this.textEditorValue = '';
            errors.forEach(error => {
                if (error.existInPortal) {
                    this.textEditorValue += this.$t('PatientPortalDashboard.ExistInPortalError', {
                        PatientCode: error.patientCode,
                        LastName: error.lastName,
                        FirstName: error.firstName
                    });
                    this.textEditorValue += '\n';
                }

                if (!error.isValidEmail) {
                    this.textEditorValue += this.$t('PatientPortalDashboard.EmailError', {
                        PatientCode: error.patientCode,
                        LastName: error.lastName,
                        FirstName: error.firstName
                    });
                    this.textEditorValue += '\n';
                }

                if (!error.isValidDob) {
                    this.textEditorValue += this.$t('PatientPortalDashboard.DOBError', {
                        PatientCode: error.patientCode,
                        LastName: error.lastName,
                        FirstName: error.firstName
                    });
                    this.textEditorValue += '\n';
                }
            });

            this.textEditorVisible = !Utils.isNullOrEmptyString(this.textEditorValue);
        },

        getActiveElement() {
            return null;
        },

        async getPatientByCode() {
            console.log('getPatientByCode', this.selectedPatientCode);
            var infoList = await this.getInfoTitle(this.selectedPatientCode);
            if (infoList.length > 0) {
                this.PatientTitle.programName = '';
                this.PatientTitle.admitDate = '';
                this.PatientTitle.dischargeDate = '';
                const { dob, firstname, lastname, age, ageFormatted } = infoList[0];

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' ' + lastname;
            }
        }
    },

    async mounted() {
        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnPatientsPortalDashboardVisible = true;
        this.OptionsRightMenu.ItemsList = this.RightMenuList;
        //this.OptionsRightMenu.active_el = this.getActiveElement();

        this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);

        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.$emit('onVisibleRightMenu', this.OptionsRightMenu);
        this.$emit('getVisibleMenu', this.OptionsRightMenu);

        /*const stored = sessionStorage.getItem('PatientPortalPatientCodeList');
        console.log('mounted', stored);

        if (stored) {
            let data = JSON.parse(stored);
            this.selectedPatientCodeList = data.patientCodeList;
            this.selectedItems = data.selectedItems;

            await this.getPatientByCode();
        }*/
    },

    beforeDestroy() {
        this.RightMenuList = JSON.parse(JSON.stringify(EnumService.PatientsPortalDashboardItems));
        /*const stored = sessionStorage.getItem('PatientPortalPatientCodeList');

        if (stored) {
            sessionStorage.removeItem('PatientPortalPatientCodeList');
        }*/
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }
};
</script>
